module.exports = __webpack_public_path__ + "media/images/brand/meta_icons/android-chrome-512x512-4567ece9d2dea0e668e6a92fdbbfdea6.png";